import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState("Processing authentication...");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const run = async () => {
      try {
        const code = searchParams.get("code");
        const state = searchParams.get("state");
        const errorParam = searchParams.get("error");
        const errorDescription = searchParams.get("error_description");

        // Handle OAuth provider errors
        if (errorParam) {
          throw new Error(errorDescription || errorParam);
        }

        // Validate required params
        if (!code || !state) {
          throw new Error("Missing 'code' or 'state' in callback URL");
        }

        setStatus("Exchanging authorization code for an app session...");

        const resp = await fetch("/api/v1/sso/exchange", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include", // IMPORTANT: required for cookies
          body: JSON.stringify({ code, state }),
        });

        if (!resp.ok) {
          const txt = await resp.text();
          throw new Error(`SSO exchange failed (${resp.status}): ${txt}`);
        }

        // Notify the app that auth state changed (so Header/AuthGate can refresh without reload)
        window.dispatchEvent(new Event("auth-changed"));

        setStatus("Authentication successful. Redirecting...");
        navigate("/", { replace: true });
      } catch (e: any) {
        setError(e?.message || "Unexpected authentication error");
        setStatus("Authentication failed");

        // Optional: redirect back home after showing the error briefly
        setTimeout(() => navigate("/", { replace: true }), 2500);
      }
    };

    run();
  }, [searchParams, navigate]);

  return (
    <div style={{ padding: 24 }}>
      <h3>{status}</h3>
      {error && <pre style={{ whiteSpace: "pre-wrap" }}>{error}</pre>}
    </div>
  );
}
